module.exports = __webpack_public_path__ + "ca624a798cba9948e529f6a7985b57c6.svg";